var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.199,
    height: 59.213,
    viewBox: "0 0 53.199 59.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_27",
    "data-name": "Union 27",
    d: "M7.792,51.424A26.424,26.424,0,0,1,0,32.615H3.311A23.29,23.29,0,0,0,43.066,49.083,23.291,23.291,0,0,0,26.85,9.326v6.506L14.407,7.915,26.85,0V6.018A26.6,26.6,0,0,1,45.408,51.424a26.6,26.6,0,0,1-37.616,0Z",
    fill: "#161615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTrack);
export default __webpack_public_path__ + "static/media/backTrack.718c180942ddf5329f19b82209efdd59.svg";
export { ForwardRef as ReactComponent };